import { LoaderFunctionArgs, replace } from 'react-router-dom';
import { useApplicationStore } from '@data';
import { ServiceType } from '@types';
import { loadServiceTypesByState } from './utils';
import { getVisitTypeUrl } from '@router/utils';
import { ROUTES } from '@constants';
import { ensureFeatureFlagsFetched } from '@lib/firebase';
import { serviceIsAddictionTreatment } from '@pages/SchedulePage/utils';
import { INTAKE_QUIZ_ROUTE_PATHNAME } from '@router/routes/routePathnames';

let cachedServiceTypes: ServiceType[] | null = null;

export default async function servicesLoader({
  request,
  params,
}: LoaderFunctionArgs): Promise<ServiceType[] | Response | null> {
  const url = new URL(request.url);
  const { serviceTypeId } = params;
  const { patient, auth, setSoonestAvailabilityDate } =
    useApplicationStore.getState();

  setSoonestAvailabilityDate('');

  // Ensure flags are loaded before we render links or make routing decisions.
  // Without this, AvailableServices may render with default-false experiment
  // flags and generate schedule links instead of intake-quiz links.
  await ensureFeatureFlagsFetched();

  if (serviceTypeId && cachedServiceTypes) {
    return cachedServiceTypes;
  }

  const stateCode = url.searchParams.get('state');
  if (!stateCode) {
    return null;
  }

  const { setStateCode } = useApplicationStore.getState();
  setStateCode(stateCode);

  const serviceTypes = await loadServiceTypesByState(stateCode);
  cachedServiceTypes = serviceTypes;

  if (serviceTypeId) {
    const serviceType = (serviceTypes || []).find(
      (item) => item.serviceTypeId === serviceTypeId,
    );

    if (!serviceType) {
      return replace(ROUTES.services.path);
    }
    const visitType = serviceType.visitTypes[0];
    const { visitTypeId } = visitType;

    if (!auth.accessToken || !patient.patientProfile) {
      const { flags } = useApplicationStore.getState();
      if (
        flags.experimentMatQuestionsEnabled &&
        flags.experimentMatQuestions &&
        serviceIsAddictionTreatment(serviceType.serviceTypeId)
      ) {
        return replace(`${INTAKE_QUIZ_ROUTE_PATHNAME}/${visitTypeId}`);
      }
      return replace(getVisitTypeUrl(visitTypeId));
    }

    return serviceTypes;
  }

  return serviceTypes;
}
